import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { googleAdsTracker } from "../services/googleAds";
import { useCheckoutStore } from "../store";

export function ResultPage({ status }: { status: "success" | "pending" | "error" }) {
  const { checkoutId, paymentId } = useCheckoutStore();

  useEffect(() => {
    if (status === "success") {
      api.getConfig().then((config) => {
        if (config?.googleAds) {
          googleAdsTracker.init(config.googleAds);
          
          if (checkoutId) {
            api.getSession(checkoutId).then((session) => {
              const items = (session.items || []).map((item: any) => ({
                id: item.shopifyVariantGid || item.id,
                name: item.title,
                price: item.unitPrice,
                quantity: item.quantity
              }));

              const addr = (session as any).address || {};
              const customerData = {
                email: session.email,
                phone: session.phone,
                firstName: session.firstName,
                lastName: session.lastName,
                street: addr.street,
                city: addr.city,
                state: addr.state,
                zip: addr.postalCode,
                country: addr.country || "BR"
              };

              googleAdsTracker.trackPurchase(
                paymentId || session.publicId,
                session.total,
                items,
                customerData,
                session.currency || "BRL"
              );
            }).catch(() => {});
          }
        }
      }).catch(() => {});
    }
  }, [status, checkoutId, paymentId]);

  const content = {
    success: {
      icon: <CheckCircle2 size={34} />,
      title: "Obrigado pela compra",
      message: "Recebemos a confirmação do PIX e estamos preparando a sincronização do seu pedido."
    },
    pending: {
      icon: <Clock size={34} />,
      title: "Pagamento pendente",
      message: "Ainda não recebemos a confirmação do PIX. Se você já pagou, aguarde alguns instantes e atualize o status."
    },
    error: {
      icon: <XCircle size={34} />,
      title: "Não foi possível confirmar",
      message: "O PIX não foi confirmado. Volte ao checkout para gerar uma nova cobrança."
    }
  }[status];

  return (
    <main className="grid min-h-screen place-items-center bg-soft px-4">
      <section className="max-w-md rounded-lg border border-line bg-white p-6 text-center shadow-sm shadow-trust/5">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-soft text-trust">{content.icon}</div>
        <h1 className="mt-4 text-2xl font-semibold text-ink">{content.title}</h1>
        <p className="mt-2 text-sm leading-6 text-slate-600">{content.message}</p>
        {status === "success" && (
          <p className="mt-4 rounded-md border border-line bg-soft p-3 text-sm text-slate-700">
            Enviaremos as atualizações do pedido por e-mail. Guarde esta página caso precise acompanhar a confirmação.
          </p>
        )}
        <Link className="mt-5 inline-block rounded-md bg-ink px-4 py-2 text-sm font-semibold text-white" to="/checkout">
          Voltar ao checkout
        </Link>
      </section>
    </main>
  );
}
